import type { ReactNode } from "react";

type FormBoxVariant = "outlined" | "filled";

interface FormBoxProps {
  children: ReactNode;
  variant?: FormBoxVariant;
}

/** A simple container with either a border or a filled background for use in forms. */
export function FormBox({ children, variant = "outlined" }: FormBoxProps) {
  const classes =
    variant === "outlined"
      ? "flex h-full flex-col rounded-lg border border-border p-4"
      : "rounded-lg bg-light-background/50 p-4";

  return <div className={classes}>{children}</div>;
}
